/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiDataUploadStatus } from './InternalApiDataUploadStatus';
import {
    InternalApiDataUploadStatusFromJSON,
    InternalApiDataUploadStatusFromJSONTyped,
    InternalApiDataUploadStatusToJSON,
    InternalApiDataUploadStatusToJSONTyped,
} from './InternalApiDataUploadStatus';

/**
 * a Batch
 * @export
 * @interface InternalApiBatch
 */
export interface InternalApiBatch {
    /**
     * 
     * @type {number}
     * @memberof InternalApiBatch
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBatch
     */
    fileName: string;
    /**
     * 
     * @type {InternalApiBatchTypeEnum}
     * @memberof InternalApiBatch
     */
    type: InternalApiBatchTypeEnum;
    /**
     * 
     * @type {InternalApiDataUploadStatus}
     * @memberof InternalApiBatch
     */
    status: InternalApiDataUploadStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBatch
     */
    statusMessage?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiBatch
     */
    createdTime: Date;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiBatchTypeEnum {
    PERSON = 'PERSON',
    PERSON_RELATION = 'PERSON_RELATION',
    PERSON_SCHEMA = 'PERSON_SCHEMA',
    TRANSACTION = 'TRANSACTION',
    TRANSACTION_UPDATE = 'TRANSACTION_UPDATE',
    TRANSACTION_SCHEMA = 'TRANSACTION_SCHEMA',
    SCENARIO = 'SCENARIO',
    RISKRULE = 'RISKRULE',
    QUERY_TEMPLATE = 'QUERY_TEMPLATE',
    CLEARANCE_RULE = 'CLEARANCE_RULE',
    CUSTOM_LIST_RECORD = 'CUSTOM_LIST_RECORD',
    CUSTOM_LIST_RECORD_RELATION = 'CUSTOM_LIST_RECORD_RELATION',
    TRANSACTION_DELETE_LIST = 'TRANSACTION_DELETE_LIST',
    PERSON_DELETE_LIST = 'PERSON_DELETE_LIST',
    PERSON_STATUS = 'PERSON_STATUS',
    CUSTOM_LIST_RECORD_ARCHIVE_LIST = 'CUSTOM_LIST_RECORD_ARCHIVE_LIST'
}


/**
 * Check if a given object implements the InternalApiBatch interface.
 */
export function instanceOfInternalApiBatch(value: object): value is InternalApiBatch {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiBatchFromJSON(json: any): InternalApiBatch {
    return InternalApiBatchFromJSONTyped(json, false);
}

export function InternalApiBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBatch {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['fileName'],
        'type': json['type'],
        'status': InternalApiDataUploadStatusFromJSON(json['status']),
        'statusMessage': json['statusMessage'] == null ? undefined : json['statusMessage'],
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function InternalApiBatchToJSON(json: any): InternalApiBatch {
    return InternalApiBatchToJSONTyped(json, false);
}

export function InternalApiBatchToJSONTyped(value?: InternalApiBatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileName': value['fileName'],
        'type': value['type'],
        'status': InternalApiDataUploadStatusToJSON(value['status']),
        'statusMessage': value['statusMessage'],
        'createdTime': value['createdTime'].toISOString(),
    };
}

